<script setup>
import { Link } from '@inertiajs/vue3';
import {SparklesIcon} from '@heroicons/vue/16/solid'

</script>

<template>
  <footer class="bg-green-100">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div class="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-12 py-4 text-sm">
        <Link
            :href="route('cgv.show')"
            class="text-white font-semibold hover:text-grey-200 flex items-center whitespace-pre"
        >
          Conditions générales & politique de confidentialité
        </Link>
        <Link
            :href="route('terms.show')"
            class="text-white font-semibold hover:text-grey-200 flex items-center whitespace-pre"
        >
          Mentions Légales
        </Link>
<!--        <Link
            :href="route('policy.show')"
            class="text-white font-semibold hover:text-grey-200 flex items-center whitespace-pre"
        >
          Politique de confidentialité
        </Link>-->
      </div>
    </div>
    <div class="bg-green-200">
      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <p class="text-center text-xs font-light text-white py-2">
          <a href="/changelog" class="hover:underline">vigIActe</a> © {{ new Date().getFullYear() }} - Une application développée par <a href="https://notariel.com" class="hover:underline">Notariel</a> <SparklesIcon class="w-3 h-3 inline-block" />
        </p>
      </div>
    </div>
  </footer>
</template>